import { useSelector } from "react-redux"
import DoctorCompensationAPI from "../../../api/doctorCompensation"
import HuddleAPI from "../../../api/huddle"
import MetricAPI from "../../../api/metric"
import { useResponseHandle } from "../../hooks"

const metricAPI = new MetricAPI()
const huddleAPI = new HuddleAPI()
const doctorCompensationAPI = new DoctorCompensationAPI()

export const fetchGroupsHandler = async (params: any) => {
  const { token, dispatch, navigate, loading } = params

  loading(true)
  const response = await metricAPI.getMetricGroupsBoarded(token)

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      let tempGroupArr: any = []

      result?.data?.forEach((group: any) => {
        tempGroupArr.push({ ...group, label: group?.group_name })
      })

      dispatch([...tempGroupArr])
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}
export const fetchRegionsHandler = async (params: any) => {
  const { token, dispatch, navigate, group } = params
  const { loading } = params

  loading(true)
  const response = await metricAPI.getMetricRegionsByGroups(token, [
    group?.group_sk,
  ])

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      let tempRegionArr: any = []

      result?.data?.regions?.forEach((region: any) => {
        tempRegionArr.push({ label: region, name: region })
      })

      dispatch([...tempRegionArr])
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}
export const fetchOfficesHandler = async (params: any) => {
  const { token, dispatch, navigate, selectedDoctorCompensationTab } = params
  const { group, region } = params
  const { loading } = params

  loading(true)
  const response = await metricAPI.getMetricPracticesByRegions(
    token,
    [group?.group_sk],
    [region.label],
  )

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      let tempOfficeArr: any =
        selectedDoctorCompensationTab?.id == "reporting"
          ? []
          : [{ practice_sk: "all", label: "All", name: "all" }]

      result?.data?.forEach((office: any) => {
        tempOfficeArr.push({
          ...office,
          practice_sk: office?.practice_sk,
          label: office?.name,
          name: office?.name,
        })
      })

      dispatch([...tempOfficeArr])
      loading(false)
    }
  } else {
    loading(false)
    navigate("/auth")
  }
}
export const fetchContracts = async (params: any) => {
  const { token, dispatch, navigate, group, region, office, status, provider } =
    params
  const { loading } = params

  loading(true)
  const response = await doctorCompensationAPI.getDoctorCompensation(
    token,
    group?.group_sk,
    region?.label,
    office?.practice_sk,
    provider?.name,
    status?.name,
  )

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      dispatch(result?.data)
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}

export const fetchActiveProviders = async (params: any) => {
  const { token, dispatch, navigate, group, region, office } = params
  const { loading } = params

  loading(true)
  const response = await doctorCompensationAPI.getActiveProviders(
    token,
    group?.group_sk,
    region?.name,
    office?.practice_sk,
  )

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      dispatch(result?.data)
    }
  }
  loading(false)
}
export const fetchContractDoctors = async (params: any) => {
  const { token, dispatch, navigate, group, region, office } = params
  const { loading } = params

  loading(true)
  const response = await doctorCompensationAPI.getContractDoctors(
    token,
    group?.group_sk,
    region?.name,
    office?.practice_sk,
  )

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      dispatch(result?.data)
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}

export const fetchSummary = async (params: any) => {
  const {
    token,
    dispatch,
    navigate,
    group,
    region,
    office,
    year,
    month,
    memo,
  } = params
  const { loading } = params

  loading(true)
  const response = await doctorCompensationAPI.getDoctorSummary(
    token,
    group?.group_sk,
    region?.name,
    office?.practice_sk,
    year?.label,
    month,
    memo?.name,
  )

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      dispatch(result?.data)
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}
export const fetchPayroll = async (params: any) => {
  const {
    token,
    dispatch,
    navigate,
    group,
    region,
    office,
    year,
    month,
    memo,
  } = params
  const { loading } = params

  loading(true)
  const response = await doctorCompensationAPI.getDoctorPayroll(
    token,
    group?.group_sk,
    region?.name,
    office?.practice_sk,
    year?.label,
    month,
    memo?.name,
  )

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      dispatch(result?.data)
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}
export const fetchLabExpenses = async (params: any) => {
  const {
    token,
    dispatch,
    navigate,
    group,
    region,
    office,
    year,
    month,
    memo,
  } = params
  const { loading } = params

  loading(true)
  const response = await doctorCompensationAPI.getLabExpenses(
    token,
    group?.group_sk,
    region?.name,
    office?.practice_sk,
    year?.label,
    month,
    memo?.name,
  )

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      dispatch(result?.data)
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}
export const fetchJournalEntries = async (params: any) => {
  const {
    token,
    dispatch,
    navigate,
    group,
    region,
    office,
    year,
    month,
    memo,
  } = params
  const { loading } = params

  loading(true)
  const response = await doctorCompensationAPI.getJournalEntries(
    token,
    group?.group_sk,
    region?.name,
    office?.practice_sk,
    year?.name,
    month?.name,
    memo?.name,
  )

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      dispatch(result?.data)
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}

export const fetchYearList = async (params: any) => {
  const { token, dispatch, navigate, office } = params
  const { loading } = params

  loading(true)
  const response = await doctorCompensationAPI.getAvailableYears(
    token,
    office?.practice_sk,
  )

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      dispatch(result?.data)
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}
export const fetchSummaryMemoList = async (params: any) => {
  const { token, dispatch, navigate, office } = params
  const { loading } = params

  loading(true)
  const response = await doctorCompensationAPI.getSummaryMemo(
    token,
    office?.practice_sk,
  )

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      dispatch(result?.data)
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}
export const fetchQboMemoList = async (params: any) => {
  const { token, dispatch, navigate, office } = params
  const { loading } = params

  loading(true)
  const response = await doctorCompensationAPI.getQboMemo(
    token,
    office?.practice_sk,
  )

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      dispatch(result?.data)
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}
export const fetchHuddleSummaryKeyMetricsData = async (params: any) => {
  const { token, dispatch, navigate, office } = params
  const { loading } = params

  loading(true)
  const response = await huddleAPI.getHuddleSummaryKeyMetricsByPratice(
    token,
    office?.practice_sk,
  )

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      dispatch(result?.data)
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}

export const fetchHuddleActiveOpportunitiesData = async (params: any) => {
  const { token, dispatch, navigate, office } = params
  const { loading } = params

  loading(true)
  const response = await huddleAPI.getHuddleActiveOpportunitiesByPratice(
    token,
    office?.practice_sk,
  )

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      dispatch(result?.data)
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}
export const fetchProviderSummaryData = async (params: any) => {
  const { token, dispatch, navigate, office } = params
  const { loading } = params

  loading(true)
  const response = await huddleAPI.getProviderSummaryByPratice(
    token,
    office?.practice_sk,
  )

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      dispatch(result?.data)
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}
export const fetchHuddleTodayAuditData = async (params: any) => {
  const { token, dispatch, navigate, office } = params
  const { loading } = params

  loading(true)
  const response = await huddleAPI.getHuddleTodayAuditByPratice(
    token,
    office?.practice_sk,
  )

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      dispatch(result?.data)
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}
export const fetchHuddleYesterdayAuditData = async (params: any) => {
  const { token, dispatch, navigate, office } = params
  const { loading } = params

  loading(true)
  const response = await huddleAPI.getHuddleYesterdayAuditByPratice(
    token,
    office?.practice_sk,
  )

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      dispatch(result?.data)
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}

export const updateHuddleHours = async (params: any) => {
  const { token, dispatch, navigate, selectedHuddleOffice } = params
  const { loading, selectedProvider, huddleData, newHours, transactionDate } =
    params

  const payload = {
    practice_sk: selectedHuddleOffice?.practice_sk,
    provider_sk: selectedProvider,
    transaction_date: transactionDate,
    hours: newHours,
  }
  loading(true)
  const response = await huddleAPI.EditHuddleByHours(token, payload)

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: true,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      dispatch()
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}
